import React from "react";

export default function Timeline() {
  return (
    <div className="py-8 sm:py-12 md:py-16 lg:py-20 xl:py-44 ">
      <div className="px-4 sm:px-6 md:px-8 lg:px-10  mx-auto">
        {/* Heading */}
      <h2 className="text-left lg:ps-20 xl:ps-32 sm:ps-20 ps-8 font-Antique text-white text-3xl sm:text-4xl md:text-5xl lg:text-[5rem] xl:text-8xl 2xl:text-[9.25rem]  leading-tight md:leading-snug 2xl:leading-[144px] tracking-[-.03em] lowercase mb-5 lg:mb-40">
          <span data-aos="fade-up">Meet our</span> <br />
          <span data-aos="fade-up" className="md:ml-[8.5rem] ml-[0.8rem]">Medical Director</span>
        </h2>

        {/* Content */}
        <div className="flex flex-col xl:flex-row md:gap-8 mt-12 lg:gap-28 max-w-7xl mx-auto">
          {/* Image */}
          <div className="w-full xl:w-1/2 flex justify-center items-center mb-6 md:mb-0">
            <img
              src="https://www.citrusdiagnosticcenter.com/wp-content/uploads/2019/10/dramin.jpg"
              alt="Dr. Kamalesh A. Amin"
              className=" w-[550px] xl:w-full xl:h-auto xl:object-cover rounded-3xl"
            />
          </div>
          {/* Text */}
          <div className="w-full xl:w-1/2 flex flex-col justify-center">
            <div className="text-center">
              <h3 data-aos="fade-up" className="text-[#cfa751] font-Antique text-2xl sm:text-3xl md:text-4xl lg:text-[2.5rem] leading-tight">
                Kamalesh A. Amin, MD
              </h3>
              <span  data-aos="fade-up" data-aso-delay="100" className="text-white text-sm sm:text-base md:text-lg lg:text-[1.3rem] font-Matter">
                - Diplomate, American Board of Radiology
              </span>
            </div>
            <div className="text-white text-xl md:text-lg lg:text-xl xl:text-[1.5rem] mt-6 sm:mt-8 md:mt-10 font-Matter md:leading-relaxed">
              <p data-aos="fade-up" data-aso-delay="200">
                With over 4 decades of experience in radiology,{" "}
                <span className="whitespace-nowrap">Dr. Kamlesh A. Amin</span> has been the driving force and backbone of the Citrus
                Diagnostic Center. Completed his residency at Wayne State
                University in Detroit in the year 1983, he was shifted to Citrus
                Company in 1989 where he led the foundation of Citrus Diagnostic
                Center.
              </p>
              <p data-aos="fade-up" data-aso-delay="300" className="mt-4">
                He practiced and became proficient in every aspect of diagnostic
                imaging. He has a keen interest in Nuclear Medicine, CT, and MRI.
                He earned the reputation of being a trusted doctor through his
                dedication by providing personalised treatment services with
                timely and precise results.
              </p>
                 <p data-aos="fade-up" data-aso-delay="300" className="mt-4">
               <b>Professional Memberships:</b> <br/> American College of Radiology, <br/>
                                          Radiological Society of North America,<br/>
                                          Florida Radiological Society,<br/>
                                          Citrus County Medical Society. 
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}